import { ACTIVE_LANGS, type Lang } from "@ecliptica/i18n";
import { Fragment, lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
import { AppLayout } from "./layouts/AppLayout";
import { accountPath, helpPath, LEGAL_PAGES, langPrefix, legalPath, sitePath } from "./lib/lang";
import { HomePage } from "./routes/home/page";
import { NotFoundPage } from "./routes/not-found/page";

// Páginas de conta num pedaço à parte (a página inicial não carrega o código das contas).
const AccountRoutes = lazy(() => import("./routes/account/routes"));
const HelpRoutes = lazy(() => import("./routes/help/routes"));
// O Mundo (conteúdo da bíblia, em PT e EN) também num pedaço à parte: a página inicial não o carrega.
const CardsPage = lazy(() => import("./routes/cards/page").then((m) => ({ default: m.CardsPage })));
const LegalDocPage = lazy(() => import("./routes/legal/page").then((m) => ({ default: m.LegalDocPage })));
const WorldPage = lazy(() => import("./routes/world/page").then((m) => ({ default: m.WorldPage })));

/** Caminho relativo para o <Route>: "/pt/conta" → "pt/conta". */
const rel = (p: string) => p.replace(/^\//, "");

/** As rotas recebem a língua de fora (vem do endereço), para o servidor e o browser renderizarem igual. Só línguas ativas. */
export function App({ lang }: { lang: Lang }) {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        {ACTIVE_LANGS.map((l) => (
          <Fragment key={l}>
            {langPrefix(l) ? <Route path={rel(langPrefix(l))} element={<HomePage lang={l} />} /> : <Route index element={<HomePage lang={l} />} />}
            <Route
              path={`${rel(accountPath(l, "account"))}/*`}
              element={
                <Suspense>
                  <AccountRoutes lang={l} />
                </Suspense>
              }
            />
            <Route
              path={rel(sitePath(l, "cards"))}
              element={
                <Suspense>
                  <CardsPage lang={l} />
                </Suspense>
              }
            />
            <Route
              path={`${rel(sitePath(l, "world"))}/*`}
              element={
                <Suspense>
                  <WorldPage lang={l} />
                </Suspense>
              }
            />
            <Route
              path={`${rel(helpPath(l, "help"))}/*`}
              element={
                <Suspense>
                  <HelpRoutes lang={l} />
                </Suspense>
              }
            />
            {LEGAL_PAGES.map((p) => (
              <Route
                key={p}
                path={rel(legalPath(l, p))}
                element={
                  <Suspense>
                    <LegalDocPage lang={l} page={p} />
                  </Suspense>
                }
              />
            ))}
          </Fragment>
        ))}
        <Route path="*" element={<NotFoundPage lang={lang} />} />
      </Route>
    </Routes>
  );
}
